import Box from "@mui/material/Box";
import React from "react";
import Confetti from "react-confetti";
import { useConfetti } from "./ConfettiContext";

export default function GlobalConfetti() {
    const { showConfetti } = useConfetti();

    if (!showConfetti) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                pointerEvents: "none",
                zIndex: (theme) => theme.zIndex.modal + 1,
            }}
        >
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                recycle={false}
                numberOfPieces={200}
                style={{ pointerEvents: "none" }}
            />
        </Box>
    );
}
